function resolveOsPdfFileName(response) {
  const contentDisposition = response.headers?.get?.('Content-Disposition');
  if (!contentDisposition) return 'OS.pdf';

  const headerFileName = /filename="?([^"]+)"?/i.exec(contentDisposition)?.[1];
  if (headerFileName === 'OS.pdf') return headerFileName;

  return 'OS.pdf';
}

function startOsPdfDownload(pdfBlob, fileName) {
  const objectUrl = window.URL.createObjectURL(pdfBlob);
  const downloadLink = document.createElement('a');
  downloadLink.href = objectUrl;
  downloadLink.setAttribute('download', fileName);
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.parentNode.removeChild(downloadLink);
  window.URL.revokeObjectURL(objectUrl);
}

async function postOsGenerateRequest(modelKey) {
  const response = await fetch(`${process.env.REACT_APP_HOST}/Os/Generate`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('conecta__token')}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ modelKey }),
  });

  if (response.status < 200 || response.status >= 300) {
    throw new Error('OS generation request failed');
  }

  return response;
}

async function readOsPdfBlob(response) {
  const pdfBlob = await response.blob();
  if (pdfBlob.size === 0) {
    throw new Error('OS generation returned empty file');
  }

  return pdfBlob;
}

export async function generateOsWorkOrderPdf(modelKey) {
  const response = await postOsGenerateRequest(modelKey);
  const pdfBlob = await readOsPdfBlob(response);
  startOsPdfDownload(pdfBlob, resolveOsPdfFileName(response));
  return { ok: true };
}

function resolveUploadedPdfFileName(fileName) {
  const baseName = String(fileName || 'OS')
    .replace(/\.[^.]+$/, '')
    .trim();
  return `${baseName || 'OS'}.pdf`;
}

const OS_CATALOG_KIND_PDF = 2;

function extractContentDispositionFileName(header) {
  if (!header) return '';

  const utfFileName = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header)?.[1];
  if (utfFileName) return decodeURIComponent(utfFileName.replace(/['"]/g, '').trim());

  const quotedFileName = /filename="?([^";]+)"?/i.exec(header)?.[1];
  return quotedFileName ? quotedFileName.trim() : '';
}

function fallbackCatalogItemFileName(catalogItem) {
  const label = String(catalogItem?.label || 'OS.pdf');
  if (catalogItem?.kind === OS_CATALOG_KIND_PDF || label.toLowerCase().endsWith('.pdf')) {
    return label;
  }

  const baseName = label.replace(/\.[^.]+$/, '').trim();
  return `${baseName || 'OS'}.pdf`;
}

function resolveCatalogItemDownloadName(response, catalogItem) {
  const headerFileName = extractContentDispositionFileName(
    response.headers?.get?.('Content-Disposition')
  );
  if (headerFileName) return headerFileName;
  return fallbackCatalogItemFileName(catalogItem);
}

async function postOsCatalogItemDownload(itemId, values) {
  const response = await fetch(`${process.env.REACT_APP_HOST}/Os/Download`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('conecta__token')}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ itemId, values }),
  });

  if (response.status < 200 || response.status >= 300) {
    throw new Error('ERR_OS_GERACAO_OU_DOWNLOAD_FALHOU');
  }

  return response;
}

export async function downloadOsCatalogItemAsPdf(itemId, values, catalogItem) {
  const response = await postOsCatalogItemDownload(itemId, values);
  const pdfBlob = await readOsPdfBlob(response);
  startOsPdfDownload(pdfBlob, resolveCatalogItemDownloadName(response, catalogItem));
  return { ok: true };
}

export async function downloadSavedOsAsPdf(values) {
  const response = await fetch(`${process.env.REACT_APP_HOST}/Os/Download`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('conecta__token')}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values ?? {}),
  });

  if (response.status < 200 || response.status >= 300) {
    throw new Error('OS conversion request failed');
  }

  const pdfBlob = await readOsPdfBlob(response);
  startOsPdfDownload(pdfBlob, 'OS.pdf');
  return { ok: true };
}

export async function downloadOsUploadAsPdf(file, values) {
  const formData = new FormData();
  formData.append('file', file, file.name);
  if (values) formData.append('values', JSON.stringify(values));

  const response = await fetch(`${process.env.REACT_APP_HOST}/Os/Convert`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('conecta__token')}`,
    },
    body: formData,
  });

  if (response.status < 200 || response.status >= 300) {
    throw new Error('OS conversion request failed');
  }

  const pdfBlob = await readOsPdfBlob(response);
  startOsPdfDownload(pdfBlob, resolveUploadedPdfFileName(file.name));
  return { ok: true };
}
